import { rankings } from '@/mocks/chiguaData';

const changeIcon = (change: string) => {
  if (change === 'up') return 'ri-arrow-up-fill text-primary-600';
  if (change === 'down') return 'ri-arrow-down-fill text-foreground-400';
  if (change === 'new') return 'text-accent-600';
  return 'ri-subtract-line text-foreground-400';
};

const rankColors = (rank: number) => {
  if (rank === 1) return 'bg-accent-500 text-white';
  if (rank === 2) return 'bg-primary-500 text-white';
  if (rank === 3) return 'bg-secondary-500 text-white';
  return 'bg-background-200 text-foreground-600';
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
            <i className="ri-trophy-line text-xl text-accent-600"></i>
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              吃瓜排行
            </h2>
            <p className="text-sm text-foreground-500 mt-0.5">实时热度榜单</p>
          </div>
        </div>

        <div className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden">
          {rankings.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 px-5 py-4 ${
                idx < rankings.length - 1 ? 'border-b border-background-200/70' : ''
              } hover:bg-background-50 transition-colors cursor-pointer`}
            >
              <div
                className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold ${rankColors(item.rank)}`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate">
                  {item.title}
                </h3>
              </div>
              {item.tag && (
                <span className="flex-shrink-0 inline-block px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-700">
                  {item.tag}
                </span>
              )}
              <span className="flex-shrink-0 text-xs text-foreground-400 whitespace-nowrap">
                {item.heat}
              </span>
              <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                {item.change === 'new' ? (
                  <span className="text-xs font-bold text-accent-600">NEW</span>
                ) : (
                  <i className={changeIcon(item.change)}></i>
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}